import { Descendant, Text } from "slate";

import { AgencyNotice, AgencyNoticeModel } from "../models/agency-notice.model";

class AgencyNoticesHelper {
  private readonly seenAgencyNoticeTokensKey = "seen_agency_notice_tokens";

  public getSeenAgencyNoticeTokens(): string[] {
    const value = localStorage.getItem(this.seenAgencyNoticeTokensKey);

    if (!value) {
      return [];
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return [];
    }
  }

  public findBestHeaderBannerAgencyNotice(
    agencyNotices: AgencyNotice[],
  ): AgencyNotice | null {
    const headerBannerAgencyNotice = agencyNotices
      .filter((an) => new AgencyNoticeModel(an).isHeaderBanner())
      .sort((a, b) => {
        return (
          new AgencyNoticeModel(b).getCreatedAtTimestamp() -
          new AgencyNoticeModel(a).getCreatedAtTimestamp()
        );
      });

    if (headerBannerAgencyNotice.length === 0) {
      return null;
    }

    return headerBannerAgencyNotice[0];
  }

  public mergeUniqueAgencyNotices(
    existing: AgencyNotice[] | null,
    incoming: AgencyNotice[],
  ): AgencyNotice[] {
    if (!existing) {
      return incoming;
    }

    const existingOnAccess = existing.filter((existing) =>
      new AgencyNoticeModel(existing).isOnAccess(),
    );

    return [...existingOnAccess, ...incoming];
  }

  public persistSeenAgencyNoticeToken(agencyNoticeToken: string): void {
    const seenAgencyNoticeTokens = this.getSeenAgencyNoticeTokens();

    localStorage.setItem(
      this.seenAgencyNoticeTokensKey,
      JSON.stringify([...seenAgencyNoticeTokens, agencyNoticeToken]),
    );
  }

  public removeSeenAgencyNoticeToken(agencyNoticeToken: string): void {
    const seenAgencyNoticeTokens = this.getSeenAgencyNoticeTokens();

    localStorage.setItem(
      this.seenAgencyNoticeTokensKey,
      JSON.stringify(
        seenAgencyNoticeTokens.filter((token) => token !== agencyNoticeToken),
      ),
    );
  }

  public slateDescendantsToString(descendants: Descendant[]): string {
    return descendants
      .map((node) => {
        if (Text.isText(node)) {
          return node.text;
        } else if ("children" in node) {
          return this.slateDescendantsToString(node.children);
        } else {
          return "";
        }
      })
      .join(" ");
  }
}

export const agencyNoticesHelper = new AgencyNoticesHelper();
